import script from "./contactPort.vue?vue&type=script&setup=true&lang=js"
export * from "./contactPort.vue?vue&type=script&setup=true&lang=js"

import "./contactPort.vue?vue&type=style&index=0&id=f518f4ee&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f518f4ee"]])

export default __exports__